<template>
  <div>
    <a-row :gutter="16">
      <a-col :span="4">
        <a-card>
          <div slot="title">
            <a-icon type="wallet" style="margin-right: 10px;"/>我的钱包
            <span style=" float: right; " @click="reloadMoney()">
              <a>
                <a-icon type="reload" :spin="reloadMoneySpin" style="margin-right: 10px;"/>刷新
              </a>
            </span>
          </div>
          <a-card-grid style="width:100%;textAlign:'center'">
            <div style=" text-align: center; ">
              <span style=" font-size: -webkit-xxx-large;color: yellowgreen; ">
                <a-icon type="dollar"></a-icon>
              </span>
              <p style=" font-size: large; ">账户余额：{{accountMoney}}</p>
              <p style=" font-size: large; ">
                <a-button type>
                  <router-link :to="{ name: 'SellerRecharge', params: { Recharge: true }}">点击充值</router-link>
                </a-button>
              </p>
            </div>
          </a-card-grid>
        </a-card>
      </a-col>
      <a-col :span="10">
        <a-card>
          <div slot="title">
            <a-icon type="user" style="margin-right: 10px;"/>我的信息
          </div>
          <a-card-grid style="width:100%;textAlign:'center'">
            <a-list itemLayout="horizontal" :dataSource="UserDataInfo">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{item.title}}</span>
                  <span slot="description">
                    <!-- <div v-if="item.title==='账户余额'">
                      {{item.content}}
                      <span style=" float: right; ">
                        <a-button type>点击充值</a-button>
                      </span>
                    </div>-->
                    <!-- <div v-else>{{item.content}}</div> -->
                    <div>{{item.content}}</div>
                  </span>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card-grid>
        </a-card>
      </a-col>
      <a-col :span="10">
        <a-card>
          <div slot="title">
            <a-icon type="shop" style="margin-right: 10px;"/>停车场信息
          </div>
          <a-card-grid style="width:100%;textAlign:'center'">
            <a-list itemLayout="horizontal" :dataSource="ParikingDatainfo">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{item.title}}</span>
                  <span slot="description">{{item.content}}</span>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card-grid>
        </a-card>
      </a-col>
      <!-- <a-col :span="20">
        <a-card>
          <div slot="title">
            <a-icon type="money-collect" style="margin-right: 10px;"/>派发优惠券情况
          </div>
          <div v-for="CouponsInfo in MainCouponsInfo" :key="CouponsInfo.index">
            <div v-if="CouponsInfo.isused===0">
              <a-divider orientation="left">未使用优惠券</a-divider>
            </div>
            <div v-if="CouponsInfo.isused===1">
              <a-divider orientation="left">已使用优惠券</a-divider>
            </div>
            <div v-if="CouponsInfo.isused===2">
              <a-divider orientation="left">过期优惠券</a-divider>
            </div>
            <a-card-grid style="width:33.33%;textAlign:'center'">
              <span>
                数量：
                <span style="color: red;">{{ CouponsInfo.sumnum }}</span>
              </span>
            </a-card-grid>
            <a-card-grid style="width:33.33%;textAlign:'center'">
              <span>
                优惠金额： ￥
                <span
                  style="color: red;"
                >{{ CouponsInfo.summoney== null?0:CouponsInfo.summoney }}</span>
                元
              </span>
            </a-card-grid>
            <a-card-grid style="width:33.33%;textAlign:'center'">
              <span>
                优惠时长：
                <span
                  style="color: red;"
                >{{ CouponsInfo.sumtime== null?0:CouponsInfo.sumtime }}</span>
              </span>
            </a-card-grid>
          </div>
        </a-card>
      </a-col>-->
    </a-row>
  </div>
</template>

<script>
import { getSellersCoupons } from '@/api/Main'
export default {
  data() {
    return {
      UserDataInfo: [],
      ParikingDatainfo: [],
      MainCouponsInfo: [],
      accountMoney: 0,
      reloadMoneySpin: false
    }
  },
  mounted() {
    this.GetSellersCouponsData()
  },
  methods: {
    reloadMoney: function() {
      this.reloadMoneySpin = true
      var VM = this
      getSellersCoupons('').then(res => {
        VM.accountMoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
        VM.reloadMoneySpin = false
      })
    },
    GetSellersCouponsData: function() {
      var VM = this
      getSellersCoupons('').then(res => {
        VM.MainCouponsInfo = res.result.CouponInfo
        const ParikingDatainfo = [
          {
            title: '停车场名称',
            content: '' + res.result.SellerParkInfo.parkingname
          },
          {
            title: '停车场联系人',
            content: res.result.SellerParkInfo.parkadminname
          },
          {
            title: '停车场联系电话',
            content: res.result.SellerParkInfo.parktel
          },
          {
            title: '到期时间',
            content: res.result.SellerParkInfo.expirydate
          },
          {
            title: '停车场地址',
            content: res.result.SellerParkInfo.parkingaddress
          }
        ]
        VM.ParikingDatainfo = ParikingDatainfo

        const UserDataInfo = [
          {
            title: '合作商名称',
            content: res.result.SellerParkInfo.sellername
          },
          {
            title: '联系人',
            content: res.result.SellerParkInfo.adminname
          },
          {
            title: '联系电话',
            content: res.result.SellerParkInfo.tel1
          },
          {
            title: '账户余额',
            content: res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
          },
          {
            title: '地址',
            content: res.result.SellerParkInfo.selleraddress
          }
        ]
        VM.accountMoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
        VM.UserDataInfo = UserDataInfo
      })
    }
  }
}
</script>

<style>
</style>
